// Sends the site's anonymous counters (lib/stats.ts) from the browser: a few at a time, a couple of
// seconds after the first, and whatever is left when the page is hidden or left.

const queue: [string, string][] = [];
let timer: number | undefined;
let listening = false;

function flush() {
  window.clearTimeout(timer);
  timer = undefined;
  if (!queue.length) return;
  const body = JSON.stringify(queue.splice(0, 30));
  if (!navigator.sendBeacon?.("/api/stats", new Blob([body], { type: "application/json" })))
    fetch("/api/stats", { method: "POST", body, keepalive: true, headers: { "content-type": "application/json" } }).catch(() => {});
  if (queue.length) flush();
}

/** Counts one event: `metric` (view, room, preroll…) of `key` (the page kind, the cam site…). */
export function track(metric: string, key: string) {
  if (typeof window === "undefined") return;
  queue.push([metric, key]);
  if (!listening) {
    listening = true;
    window.addEventListener("pagehide", flush);
    document.addEventListener("visibilitychange", () => document.visibilityState === "hidden" && flush());
  }
  if (timer === undefined) timer = window.setTimeout(flush, 2000);
}
